import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { Button, Row, Col, Modal, Form } from "react-bootstrap";
import { Clipboard2Heart } from "react-bootstrap-icons";
import Moment from "react-moment";
import { AppDispatch, RootState } from "../../../_store";
import { newsUpdate, newsDelete, newsGetList, newsAdd } from "../../../_store/thunks/news.thunk";
import AddButton from "../../../components/AddButton";
import EditButton from "../../../components/EditButton";
import { INews } from "../../../models/INews";
import DeleteButton from "../../../components/DeleteButton";
import SubmitButton from "../../../components/SubmitButton";
import { removeImage } from "../../../_store/thunks/image.thunks";
import { IMAGE } from "../../../constants/endpoints";

interface INewsEditProps {
    setErrorAlert: any;
}

export default function NewsEdit(props: INewsEditProps) {

    const dispatch = useDispatch<AppDispatch>()
    const news = useSelector((state: RootState) => state.news.news);

    const [showCreateNewsModal, setShowCreateNewsModal] = useState(false);
    const [currentDeletionNews, setCurrentDeletionNews] = useState<INews | null>(null);
    const [currentEditingNews, setCurrentEditingNews] = useState<INews | null>(null);
    const [hasChanges, setHasChanges] = useState(false);

    function editCurrentEditingNewsState(fieldName: string, value: any) {
        setCurrentEditingNews((prev) => ({ ...prev, [fieldName]: value } as INews));
        setHasChanges(true);
    }

    function addNews(event: any) {
        event.preventDefault();
        let headline = event.target.headline.value;
        let description = event.target.description.value;
        let showInMainPage = event.target.showInMainPage.checked;
        let date = event.target.date.value;
        let image = event.target.image.files;
        const formData = new FormData();
        if (image) {
            formData.append('image', image[0]);
        }

        formData.append("headline", headline);
        formData.append("description", description);
        formData.append("showInMainPage", `${showInMainPage}`);
        formData.append("date", date);

        dispatch(newsAdd(formData)).then((x: any) => {
            if (x.error) {
                props.setErrorAlert(x.error.message);
            }
            else {
                dispatch(newsGetList())
                setShowCreateNewsModal(false);
            }
        });

    }

    function updateNews(event: any) {
        event.preventDefault();
        if (currentEditingNews) {

            const formData = new FormData();

            if (currentEditingNews.imageId == null) {
                let image = event.target.image?.files;
                if (image) {
                    formData.append('image', image[0]);
                }
            }

            formData.append("id", `${currentEditingNews.id}`);
            formData.append("headline", currentEditingNews.headline);
            formData.append("description", currentEditingNews.description);
            formData.append("showInMainPage", `${currentEditingNews.showInMainPage}`);
            formData.append("date", `${currentEditingNews.date}`);

            dispatch(newsUpdate(formData)).then((x: any) => {
                if (x.error) {
                    props.setErrorAlert(x.error.message);
                }
                else {
                    dispatch(newsGetList())
                    resetEditing();
                }
            });
        }
    }

    function resetEditing() {
        setCurrentEditingNews(null);
        setHasChanges(false);
    }

    function deleteImage(id: number) {
        dispatch(removeImage(id)).then((x: any) => {
            if (x.error) {
                props.setErrorAlert(x.error.message);
            }
            else {
                setCurrentEditingNews((old) => ({ ...old, image: null }) as INews)
                dispatch(newsGetList())
                setHasChanges(true);
            }
        });
    }

    function deleteNews() {
        if (currentDeletionNews) {
            dispatch(newsDelete(currentDeletionNews.id)).then((x: any) => {
                if (x.error) {
                    props.setErrorAlert(x.error.message);
                }
                else {
                    dispatch(newsGetList());
                    setCurrentDeletionNews(null);
                }
            });
        }
    }

    return (<>
        <AddButton
            size='sm'
            onClick={() => setShowCreateNewsModal(true)} />
        <hr></hr>
        {news?.map((n) => (
            <Row style={{ paddingBottom: "30px" }} key={n.id}>
                <Col xs={3}>
                    <img src={`/api/${IMAGE}?id=${n.imageId}`}
                        style={{ width: "100%" }}
                        alt="conpany-news"></img>
                </Col>
                <Col>
                    <EditButton
                        size='sm'
                        onClick={() => setCurrentEditingNews(n)} />
                    <DeleteButton
                        size='sm'
                        onClick={() => setCurrentDeletionNews(n)} />

                    {n.showInMainPage &&
                        <h3 style={{ float: "right" }}>
                            <Clipboard2Heart color="red"></Clipboard2Heart>
                        </h3>
                    }
                    <p>
                        <h4>{n.headline}</h4>
                        <span><Moment format="DD.MM.YYYY">{n.date}</Moment></span>
                    </p>
                    <p>
                        {n.description}
                    </p>
                </Col>
            </Row>
        )
        )}

        <Modal show={showCreateNewsModal}
            onHide={() => setShowCreateNewsModal(false)}
            size="lg"
            backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    Добавить новость
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={addNews}>
                    <Form.Group controlId="headline">
                        <Form.Label>Заголовок:</Form.Label>
                        <Form.Control type="text" />
                    </Form.Group>
                    <Form.Group controlId="description">
                        <Form.Label>Описание:</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </Form.Group>
                    <Form.Group controlId="date">
                        <Form.Label>Выберите дату:</Form.Label>
                        <Form.Control type="date" />
                    </Form.Group>
                    <Form.Group controlId="showInMainPage">
                        <Form.Label>Показывать на главной:</Form.Label>
                        <Form.Check />
                    </Form.Group>
                    <Form.Group controlId="image">
                        <Form.Label>Загрузите изображение:</Form.Label>
                        <Form.Control type="file" accept=".jpef, .png, .jpg" />
                    </Form.Group>
                    <hr></hr>
                    <SubmitButton />
                </Form>

            </Modal.Body>
        </Modal>


        {currentEditingNews &&
            <Modal show={currentEditingNews != null}
                onHide={() => setCurrentEditingNews(null)}
                size="lg"
                backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Редактировать новость
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={updateNews}>
                        <Form.Group>
                            <Form.Label>Заголовок:</Form.Label>
                            <Form.Control type="text"
                                value={currentEditingNews.headline}
                                onChange={(event) => editCurrentEditingNewsState("headline", event.target.value)} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Описание:</Form.Label>
                            <Form.Control as="textarea" rows={3}
                                value={currentEditingNews.description}
                                onChange={(event) => editCurrentEditingNewsState("description", event.target.value)} />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Выберите дату:</Form.Label>
                            <Form.Control
                                value={currentEditingNews.date.toString().slice(0, 10)}
                                onChange={(event) => editCurrentEditingNewsState("date", event.target.value)}
                                type="date" />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Показывать на главной:</Form.Label>
                            <Form.Check
                                checked={currentEditingNews.showInMainPage}
                                onChange={(event) => editCurrentEditingNewsState("showInMainPage", event.target.checked)} />
                        </Form.Group>

                        <p style={{ display: "flex" }}>
                            {currentEditingNews.imageId && (
                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <img
                                        alt="not found"
                                        width={"250px"}
                                        src={`/api/${IMAGE}?id=${currentEditingNews.imageId}`}
                                    />
                                    <Button
                                        variant='danger'
                                        style={{ position: "absolute" }}
                                        size='sm'
                                        onClick={() => deleteImage(currentEditingNews.imageId!)}>
                                        Удалить
                                    </Button>

                                </div>
                            )}
                        </p>
                        {currentEditingNews.imageId == null && <Form.Group controlId="image" className="mb-3">
                            <Form.Label>Загрузите изображение:</Form.Label>
                            <Form.Control type="file" accept=".jpef, .png, .jpg"
                                onInput={() => setHasChanges(true)} />
                        </Form.Group>
                        }

                        <p>
                            <SubmitButton disabled={!hasChanges} />
                        </p>
                    </Form>
                </Modal.Body>
            </Modal>
        }

        <Modal show={currentDeletionNews != null} onHide={() => setCurrentDeletionNews(null)}>
            <Modal.Header closeButton>
                <Modal.Title>Точно удалить новость {currentDeletionNews?.headline}?</Modal.Title>
            </Modal.Header>
            <Modal.Footer>
                <Button variant='outline-secondary' onClick={() => setCurrentDeletionNews(null)}>
                    Отмена
                </Button>
                <DeleteButton onClick={() => deleteNews()} size={undefined} />
            </Modal.Footer>
        </Modal>

    </>);
}